import React, { useState, useEffect, Suspense } from "react";
import DropWindow from "./../components/DropWindow";
import { useContent } from "../i18n/useContent";

function Aktuellt() {
  const [dropdown, setDropdown] = useState('');
  const Content = useContent('aktuellt');

  function getAktuellt() {
    setDropdown('aktuellt');
  }

  useEffect(() => {
    getAktuellt();
  }, []);

  return (
    <>
      <DropWindow dropdown={dropdown} setDropdown={setDropdown} >
        <Suspense fallback={<div>...</div>}>
          <Content />
        </Suspense>
      </DropWindow>
    </>
  );
}

export default Aktuellt;
